import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UiThemeService } from './core/services/ui-theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'keyboard-admin';

  constructor(
    private translate: TranslateService,
    private uiThemeService: UiThemeService
  ) {}

  ngOnInit(): void {
    // Set fallback language (used when a translation is missing in current language)
    this.translate.setFallbackLang('en');
    this.translate.use('en');
    this.uiThemeService.init();
  }
}
